import { z } from "zod";
import {
  isoDateTimeString,
  pagePaginationQuerySchema,
  pagedResponseSchema,
  uuidSchema,
} from "./common";

export const actorRoleSchema = z.enum([
  "WORKER",
  "EMPLOYER",
  "ADMIN",
  "SYSTEM",
]);

export const activityLogSchema = z.object({
  id: z.string(),
  actorUserId: uuidSchema.nullable(),
  actorRole: actorRoleSchema,
  actorPhone: z.string().nullable().optional(),
  orgId: uuidSchema.nullable().optional(),
  action: z.string(),
  targetType: z.string().nullable().optional(),
  targetId: z.string().nullable().optional(),
  metadata: z.record(z.string(), z.unknown()).nullable().optional(),
  ipAddress: z.string().nullable().optional(),
  userAgent: z.string().nullable().optional(),
  createdAt: isoDateTimeString,
});

export const activityLogQuerySchema = pagePaginationQuerySchema.extend({
  actorUserId: uuidSchema.optional(),
  // Org-scoped audit feed (employer detail page). Matches ActivityLog.orgId,
  // which employer-side writes populate (postings, invites, wallet, members).
  orgId: uuidSchema.optional(),
  action: z.string().optional(),
  targetType: z.string().optional(),
  targetId: z.string().optional(),
  from: isoDateTimeString.optional(),
  to: isoDateTimeString.optional(),
});

// Org-scoped activity feed query (employer dashboard).
// `actionPrefix` lets the UI filter by domain (e.g. "posting.", "wallet.").
export const orgActivityQuerySchema = pagePaginationQuerySchema.extend({
  actorUserId: uuidSchema.optional(),
  action: z.string().optional(),
  actionPrefix: z.string().optional(),
  from: isoDateTimeString.optional(),
  to: isoDateTimeString.optional(),
});

export const activityLogListResponseSchema =
  pagedResponseSchema(activityLogSchema);

export const orgActivityResponseSchema = activityLogListResponseSchema;

export type ActorRole = z.infer<typeof actorRoleSchema>;
export type ActivityLog = z.infer<typeof activityLogSchema>;
export type ActivityLogQuery = z.infer<typeof activityLogQuerySchema>;
export type OrgActivityQuery = z.infer<typeof orgActivityQuerySchema>;
export type ActivityLogListResponse = z.infer<
  typeof activityLogListResponseSchema
>;
export type OrgActivityResponse = z.infer<typeof orgActivityResponseSchema>;
